import React from "react"

export default function FlashcardsGenericInfo() {
    return (
        <div className="flashcards-generic-info stay-sharp-info-card">
            <div className="stay-sharp-info-card__mix-em-up d-flex">
                <img width="177" height="177" alt="" src={`${process.env.PUBLIC_URL}/assets/images/icons/sections/flashcard-icon_circle_white.svg`} />
            </div>
            <div>
                <h2 className="h6 info-card-title">Flashcard Overview</h2>
                <p>
                    Flashcards are a great way to study because they promote active recall, which leads to better memory retention and deeper understanding of information.
                </p>
                <p>
                    Essentially, when you try to generate an answer on your own, the information moves from short-term to long-term memory. We want information in your long-term memory, so you’ll recall it when you need it on high stakes exams.
                </p>
                <p>
                    Happy flashing!
                </p>
            </div>
        </div>
    )
}